import React, { useContext, useEffect } from "react";
import { Container, Content } from "rsuite";
import Sidebar from "./Sidebar";
import { GlobalContext } from "@/Contexts/GlobalContext";
import Loader from "../Loader";
import "./Layout.css";
import { useWindowDimension } from "../../Hooks/resizeHooks";
import AIChat from "./AIChat/AIChat";
import { SubscriptionContext } from "../../Contexts/SubscriptionContext";
import { SUBSCRIPTION_FEATURE_CODE } from "../../Constants/SubscriptionConstants";

const Layout = ({ hideSidebar, ...props }) => {
  const [width] = useWindowDimension();
  const { loading, darkMode } = useContext(GlobalContext);
  const { subscription } = useContext(SubscriptionContext);
  const subFeatures = subscription?.subscriptionFeatures;

  const [expanded, setExpanded] = React.useState(true);
  const toggleSidebar = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    setExpanded(width > 1280);
  }, [width]);

  useEffect(() => {
    const root = document.getElementsByTagName("html")[0]; // '0' to assign the first (and only `HTML` tag)

    if (darkMode) {
      root.setAttribute("class", "dark");
    } else {
      root.removeAttribute("class", "dark");
    }
  }, [darkMode]);

  return (
    <>
      <div className={`sc-one-app`}>
        <div className="sc-viewport">
          <Container>
            {(!hideSidebar && (
              <Sidebar expanded={expanded} toggleSidebar={toggleSidebar} />
            )) ||
              null}

            <Container className="sc-main">
              <Content>{props.children}</Content>
            </Container>
          </Container>
          {subFeatures.some(
            (obj) => obj.featureCode === SUBSCRIPTION_FEATURE_CODE.AI_CHAT
          ) && <AIChat />}
        </div>
      </div>
      {(loading && <Loader />) || null}
    </>
  );
};

export default Layout;
